import { useMediaQuery } from "@material-ui/core";
import Box from "@mui/material/Box";

export default function LabelSelector({ optionSection }) {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  const getLabel = () => {
    switch (optionSection) {
      case "car":
        return isXs ? "Selecciona la marca" : "Por favor, selecciona la marca de tu auto";
      case "model":
        return isXs ? "Selecciona el modelo" : "Por favor, selecciona el modelo de tu auto";
      case "product":
        return isXs ? "¡Listo! Explora los productos" : "¡Tenemos los siguientes productos para ti!";
      case "typeAc":
        return "Selecciona el tipo de aceite o producto";
      case "brandAc":
        return "Selecciona la marca";
      case "specAc":
        return "Selecciona de acuerdo a la especificación";
      default:
        return "";
    }
  };

  return (
    <Box
      component="div"
      sx={{
        fontSize: { xs: "15px", md: "30px" },
        fontWeight: "500",
        paddingBottom: { xs: '15px', md: "30px" },
        paddingTop: { xs: '15px', md: "30px" },
        paddingLeft: "8px",
        paddingRight: "8px",
        fontFamily: "Nunito Sans, sans-serif",
      }}
    >
      {getLabel()}
    </Box>
  );
}